/* =========================================================================
   wordmark.tsx — sandstone TENU, weathered-brass RE and a soft cast shadow.
   Pure CSS/SVG (styles in public/assets/tenure.css) — no raster assets.

   Sizes:
     sm — sidebar brand
     md — estate access gate
     lg — auth gate hero (pair with `tagline` for the CFO-tone strapline)
   ========================================================================= */

export type WordmarkSize = "sm" | "md" | "lg";

export function Wordmark({
  size = "md",
  tagline = false,
}: Readonly<{ size?: WordmarkSize; tagline?: boolean }>) {
  return (
    <span className={`wordmark wordmark-${size}`}>
      <span className="wm-row" role="img" aria-label="TENURE">
        <span className="wm-tenu" data-text="TENU" aria-hidden="true">
          TENU
        </span>
        <span className="wm-re" data-text="RE" aria-hidden="true">
          RE
        </span>
      </span>
      {tagline && (
        <span className="wm-tagline">Long-term occupancy, modelled.</span>
      )}
    </span>
  );
}
